import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const protectionItems = [
    'Protecting Properties',
    'Protecting People',
    'Protecting Businesses',
    'Protecting Families'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % protectionItems.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/a76fc84099da4ca5f9486c73960e2672/25e7a855e9df19c2e16e91a3a53e3a8e.png"
          alt="Safe Home Environment"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-4 sm:px-6 lg:px-8 py-20 sm:py-32">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-full mb-6 sm:mb-8">
              <i className="ri-shield-check-line text-[#f59e0b] text-base sm:text-lg mr-2"></i>
              <span className="text-white text-xs sm:text-sm font-semibold">Family Owned</span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4">
              We Protect What Matters Most
            </h1>
            
            <div className="h-16 sm:h-20 mb-6 sm:mb-8 flex items-center">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                {protectionItems.map((item, index) => (
                  <span
                    key={index}
                    className={`text-[#f59e0b] absolute transition-all duration-700 ${
                      index === currentIndex
                        ? 'opacity-100 translate-y-0'
                        : 'opacity-0 translate-y-4'
                    }`}
                  >
                    {item}
                  </span>
                ))}
              </h2>
            </div>
            
            <p className="text-base sm:text-lg lg:text-xl text-gray-200 mb-8 sm:mb-10 leading-relaxed max-w-2xl">
              For more than 30 years, LCA Group has helped clients across the United States manage environmental risk in the places people live, learn, and work.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-12 sm:mb-16">
              <Link
                to="/contact#contact-form"
                className="bg-[#f59e0b] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-[#d97706] transition-all duration-300 shadow-2xl hover:shadow-[#f59e0b]/50 hover:scale-105 whitespace-nowrap cursor-pointer text-center"
              >
                Request Inspection
              </Link>
              <button
                onClick={() => scrollToSection('services')}
                className="bg-white/10 backdrop-blur-sm text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer text-center"
              >
                View Services
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-8">
              <div className="text-center sm:text-left">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">30+</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wider">Years Experience</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">38+</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wider">States Served</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wider">Family Owned</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <button
          onClick={() => scrollToSection('nj-lead')}
          className="w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
